import { PageHeader as PageHeaderBase } from 'shared';
import styled, { from, to } from 'theme';

export const BackButton = styled.div`
  width: 1.875rem;
  height: 1.875rem;
  background-image: url(${props => props.theme.variables.icons.svg.backButton});
  background-size: contain;
  position: relative;
  top: -0.125rem;
`;

export const PageHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  ${to('md')} {
    flex-flow: column;
  }
`;

export const PageHeader = styled(PageHeaderBase)`
  h1,
  .page-header__title {
    display: flex;
    align-items: center;
  }

  .page-header__title-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 12rem;

    ${from('md')} {
      max-width: 9rem;
    }

    ${from('lg')} {
      max-width: 18rem;
    }

    ${from('xlg')} {
      max-width: 25rem;
    }
  }

  .page-header__back-button {
    margin-right: 0.75rem;
  }

  .page-header__environment {
    margin: 0 0.5rem;
    ${to('md')} {
      margin: 0 0 0.25rem 0.5rem;
    }
  }

  ${from('md')} {
    .page-header__environment {
      margin: -0.5rem auto 0 1.5rem;
    }
  }

  ${to('lg')} {
    h1 {
      flex-flow: column;
    }
  }

  ${to('md')} {
    margin-top: 1rem;
    > div {
      display: flex;
      justify-content: center;
      padding: 0;
      margin-top: 1.5rem;
    }
  }
`;

export const DeleteWrapper = styled.div`
  ${to('md')} {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
  }

  .button--application-delete {
    ${from('md')} {
      width: 150px;
    }

    .button__text-wrapper {
      margin-right: 1rem;
      font-weight: ${props => props.theme.variables.fonts.weight.bold};
      font-size: ${props => props.theme.variables.fonts.size.base};
      color: ${props => props.theme.variables.colors.red};
    }
  }
`;
